export const ENERGY_UNITS = {
  MW: 'MW',
  // KW: 'KW',
}
export const energyUnits = Object.values(ENERGY_UNITS)

export const RANGE_TYPES = {
  HOUR: 'H',
  DAY: 'D',
  WEEK: 'W',
  MONTH: 'M',
  YEAR: 'Y',
}
